export default __webpack_public_path__ + "static/media/twitter.e591df06.svg";